
(function () {
  const mySwiperconproitembot = new Swiper('.swiper-number', {
    slidesPerView: 4,
    slidesPerColumn: 1,
    watchSlidesProgress: true,
    keyboard: { enabled: true },
  });
  const mySwiperconproitem = new Swiper('.swper-bigboxs', {
    slidesPerView: 1,
    direction: 'vertical',
    keyboard: { enabled: true },
    thumbs: {
      swiper: mySwiperconproitembot,
    },
  });
  let indexs = 0;
  let timessss = setInterval(function () {
    indexs++;
    if (indexs > 2) {
      indexs = 0;
    }
    mySwiperconproitem.slideTo(indexs);
  }, 3000);
  $(".ss-hoab").click(function () {
    clearInterval(timessss);
  });
})();
